export const FILE_KEYS = [
  'CROPPED_CURRENT_FILE',
  'CROPPED_DEFAULT_FILE',
  'CURRENT_FILE',
  'DEFAULT_FILE',
];
